export default __webpack_public_path__ + "static/media/background.fcb73a60.png";